module.exports = __webpack_public_path__ + "img/bus-sm-orange.7d35e8b6.svg";